import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../Pages/Login/Login'
import Frame from '../Pages/Frame/Frame'

import Home from '../Pages/Home/index'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Frame',
    component: Frame,
    redirect: '/meal',
    children: [
      {
        path: '/meal',
        name: 'meal',
        component: () => import('@/Pages/mealManage/meal.vue')
      },
      {
        path: '/mealDay',
        name: 'mealDay',
        component: () => import('@/Pages/mealManage/mealDay.vue')
      },
      {
        path: '/orderRecord',
        name: 'orderRecord',
        component: () => import('@/Pages/mealManage/orderRecord.vue')
      },
      {
        path: '/orderReport',
        name: 'orderReport',
        component: () => import('@/Pages/mealManage/orderReport.vue')
      },
      {
        path: '/navMange',
        name: 'navMange',
        component: () => import('@/Pages/SystemManagement/navMange.vue')
      },
      {
        path: '/roleMange',
        name: 'roleMange',
        component: () => import('@/Pages/SystemManagement/roleMange.vue')
      },
      {
        path: '/useMange',
        name: 'useMange',
        component: () => import('@/Pages/SystemManagement/useMange.vue')
      }
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router
